import React from "react";
import { Form, Col } from "react-bootstrap";
import { InputField } from "../../../components/InputField";

const ElevenLabsFields = ({ state, handleChange }) => {
    return (
        <>
            <Form.Row>
                <Form.Group as={Col} lg="6" xs="12">
                    <InputField
                        type="text"
                        name="voiceId"
                        label="Voice ID"
                        placeholder="Digite o Voice ID"
                        value={state.voiceId}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>
                <Form.Group as={Col} lg="6" xs="12">
                    <InputField
                        type="number"
                        name="stability"
                        label="Stability"
                        placeholder="Digite o Stability"
                        value={state.stability}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} lg="6" xs="12">
                    <InputField
                        type="number"
                        name="similarityBoost"
                        label="Similarity Boost"
                        placeholder="Digite o Similarity Boost"
                        value={state.similarityBoost}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>
                <Form.Group as={Col} lg="6" xs="12">
                    <InputField
                        type="text"
                        name="style"
                        label="Style"
                        placeholder="Digite o Style"
                        value={state.style}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} lg="6" xs="12">
                    <InputField
                        type="number"
                        name="speed"
                        label="Speed"
                        placeholder="Digite o Speed"
                        value={state.speed}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>
            </Form.Row>
        </>
    );
};

export default ElevenLabsFields;